import videoLazyLoadStart from "./modules/videos-lazy-load";
import animations from "./modules/animations";

/*
 * The script is printed in the footer, so the DOM is ready -- the sections on screen are animated right away
 * instead of after the page load (which delayed the Largest Contentful Paint).
 */
animations();

/*
 * The images of the hidden slides and the inactive service images are printed with data-src/data-srcset
 * (see hm_get_responsive_image()), because the browser lazy loads every image within ~1250px of the screen
 * and they would be downloaded together with the hero image. The other images of a slider are clipped,
 * so they are switched to eager loading as well, otherwise they would start loading only when they slide in.
 */
function loadSliderImages( slider ) {
	slider.querySelectorAll( "img[data-src]" ).forEach( image => {
		if ( image.dataset.srcset ) {
			image.srcset = image.dataset.srcset;
			image.removeAttribute( "data-srcset" );
		}

		image.src = image.dataset.src;
		image.removeAttribute( "data-src" );
	} );

	slider.querySelectorAll( "img[loading=\"lazy\"]" ).forEach( image => {
		image.loading = "eager";
	} );
}

function observeSliders() {
	const sliderImagesObserver = new IntersectionObserver( entries => {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				loadSliderImages( entry.target );
				sliderImagesObserver.unobserve( entry.target );
			}
		} );
	}, { rootMargin: "300px 0px" } );

	document.querySelectorAll( ".swiper, .js-social-infiniteslide, .js-services-images" ).forEach( slider => {
		sliderImagesObserver.observe( slider );
	} );
}

/*
 * The background videos (the home hero video is ~9 MB) and the slider images are loaded on the first user interaction.
 * Until then the poster image is shown, so they don't take the bandwidth from the page content.
 */
const interactionEvents = ["pointerdown", "pointermove", "keydown", "touchstart", "scroll", "wheel"];

function onFirstInteraction() {
	interactionEvents.forEach( event => {
		window.removeEventListener( event, onFirstInteraction, { passive: true } );
	} );

	videoLazyLoadStart();
	observeSliders();
}

interactionEvents.forEach( event => {
	window.addEventListener( event, onFirstInteraction, { passive: true } );
} );
